import * as Yup from 'yup';

export const ProfileImageSchema = Yup.object()
  .shape({
    image: Yup.mixed<File>().required('Image is required'),
  })
  .required();
